<template>
  <!-- <div class="bg-services"> -->
    <!-- <div class="services-mob"> -->
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <ul class="choose-plan">
              <li :class="{active: changePlan == 'b2cSodre'}" @click="changePlan = 'b2cSodre'">
                Para Você
              </li>
              <li :class="{active: changePlan == 'b2bSodre'}" @click="changePlan = 'b2bSodre'">
                Para Sua Empresa
              </li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-xs-12">
            <h3 class="bold margin-b0 margin-t30">PLANO</h3>
            <p  v-if="changePlan == 'b2cSodre'">Ideal para você :</p>
            <p  v-else>Indispensável à sua empresa :</p>

            <b2cSodre class="margin-t20" type="adhesion" v-if="changePlan == 'b2cSodre'"></b2cSodre>
            <b2bSodre class="margin-t20" type="adhesion" v-else></b2bSodre>
          </div>
        </div>
        
      </div>
   
</template>

<style lang="scss" scoped>
  .bg-services {
    margin: -100px -20px -50px;
  }

  .img-services {
    background-image: url(../../assets/img/img-services.svg);
  }

  .services-mob {
    display: none;
  }

  .btn-large,
  .btn-large:active,
  .btn-large:focus,
  .btn-large:hover {
    padding: 10px 30px;
  }

  .choose-plan {
    margin-top: 20px;
    li {
      position: relative;
      display: inline-block;
      width: 50%;
      color: #613A7D;
      background-color: #F2F2F2;
      padding: 10px 5px;
      text-align: center;
      font-weight: bold;
      font-size: 1.5em;
      cursor: pointer;
      &:first-child {
        float: left;
        -webkit-border-radius: 10px 0 0 10px;
        border-radius: 10px 0 0 10px;
      }
      &:last-child {
        float: right;
        -webkit-border-radius: 0 10px 10px 0;
        border-radius: 0 10px 10px 0;
      }
      &.active {
        color: white;
        background: #613A7D;
        &::after {
          top: 100%;
        	left: 50%;
        	border: solid transparent;
        	content: " ";
        	height: 0;
        	width: 0;
        	position: absolute;
        	pointer-events: none;
        	border-color: rgba(97, 58, 125, 0);
        	border-top-color: #613A7D;
        	border-width: 15px;
        	margin-left: -15px;
        }
      }
    }
    li:hover {
      background-color: #E5E5E5;
    }
    li:hover.active {
      background-color: #613A7D;
      cursor: default;
    }
  }

  @media screen and (max-width: 479px) {
    .choose-plan li {
      min-height: 80px;
    }
    .choose-plan li:first-child {
     padding: 25px 5px;
    }
  }

  @media screen and (max-width: 699px) {
    .services-mob {
      display: block;
      padding: 50px 20px 50px;
    }
  }

  @media only screen and (max-width: 900px) {
    .bg-services {
      margin: -50px -20px -50px;
    }
  }
</style>

<script>
import b2bSodre from "./plans/b2b-sodre.vue"
import b2cSodre from "./plans/b2c-sodre.vue"

export default {
  data() {
    return {
      changePlan: 'b2cSodre'
    }
  },
  components: {b2bSodre, b2cSodre}
}
// const baseSvg = require('!!raw-loader!../../assets/img/img-services.svg');
//
// export default {
//   data() {
//     return {}
//   },
//
//   mounted() {
//     let vm = this;
//     let svg = $(baseSvg);
//     svg.appendTo(this.$el);
//
//   }
// }

</script>



// WEBPACK FOOTER //
// services-sodre.vue?7343ecd0